const styles = {
  errorContainer: {
    background: 'url(./../../images/RMaxErrorBG-light.jpg)',
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    '& > *': {
      boxSizing: 'border-box'
    }
  },
  errorContent: {
    background: 'url(./../../images/RMaxErrorBG-light.jpg)',
    width: '1400px',
    height: '755px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
    borderRadius: '20px',
    position: 'relative',
    '@media (max-width: 1024px)': {
      width: '80%',
      height: 'auto',
      minHeight: '500px'
    }
  },
  contentWrapper: {
    display: 'flex',
    '@media (max-width: 1024px)': {
      width: '80%'
    }
  },
  animationContainer: {
    transform: 'translate(-55%, 2%)',
    '@media (max-width: 1024px)': {
      transform: 'translate(-30%, 2%)'
    }
  },
  textContainer: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    padding: 20,
    '@media (max-width: 1024px)': {
      position: 'relative',
      padding: 20,
      textAlign: 'center'
    }
  },
  errorTitle: {
    fontSize: 44,
    color: 'rgba(12, 107, 185, 1)',
    fontWeight: 700,
    '@media (max-width: 480px)': {
      fontSize: 28
    },
    fontFamily: 'Oxanium !important'
  },
  errorDescription: {
    color: 'rgba(46, 59, 88, 1)',
    fontSize: 18,
    marginTop: 16,
    marginBottom: 24,
    maxWidth: 400,
    lineHeight: 1.5,
    fontFamily: 'Oxanium !important'
  },
  errorCategory: {
    marginBottom: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  categoryChip: {
    backgroundColor: 'rgba(12, 107, 185, 0.1)',
    color: 'rgba(12, 107, 185, 1)',
    fontWeight: 600,
    fontSize: 12
  },
  buttonContainer: {
    display: 'flex',
    gap: '16px',
    marginTop: 10,
    flexWrap: 'wrap',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  button: {
    width: 140,
    alignSelf: 'center',
    backgroundColor: 'rgba(12, 107, 185, 1)',
    textTransform: 'none',
    height: 34,
    textDecoration: 'none',
    fontWeight: 600,
    color: '#FFFFFF',
    fontSize: 14,
    '&:hover': {
      backgroundColor: 'rgba(8, 85, 148, 1)'
    }
  },
  secondaryButton: {
    width: 140,
    alignSelf: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    textTransform: 'none',
    height: 34,
    textDecoration: 'none',
    fontWeight: 600,
    color: 'rgba(12, 107, 185, 1)',
    fontSize: 14,
    border: '2px solid rgba(12, 107, 185, 1)',
    '&:hover': {
      backgroundColor: 'rgba(12, 107, 185, 0.1)'
    }
  },
  linkContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  icon: {
    fontSize: 20
  },

  errorDetailsContainer: {
    marginTop: 16,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: 8,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    maxWidth: 500,
    overflow: 'hidden'
  },
  errorDetails: {
    padding: 16,
    fontSize: 12,
    fontFamily: 'monospace',
    maxHeight: 120,
    overflow: 'auto',
    color: 'rgba(46, 59, 88, 1)',
    lineHeight: 1.4,
    '& strong': {
      color: 'rgba(12, 107, 185, 1)',
      fontWeight: 600
    },
    '& pre': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      padding: 8,
      borderRadius: 4,
      marginTop: 4,
      border: '1px solid rgba(0, 0, 0, 0.1)',
      margin: 0,
      fontSize: 10,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word'
    }
  },
  toggleDetailsButton: {
    fontSize: 12,
    color: 'rgba(12, 107, 185, 1)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    padding: '8px 16px',
    flexWrap: 'wrap',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgba(255, 255, 255, 0.98)'
  },
  copyButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: 10,
    height: 28,
    backgroundColor: 'rgba(76, 175, 80, 1)',
    '&:hover': {
      backgroundColor: 'rgba(56, 142, 60, 1)'
    }
  },
  reportButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: 10,
    height: 28,
    backgroundColor: 'rgba(255, 152, 0, 1)',
    '&:hover': {
      backgroundColor: 'rgba(245, 124, 0, 1)'
    }
  }
};

export default styles;
